import React from 'react';

import {
  TypeFilterValue,
  RoomsFilterValue,
  GenderFilterValue,
  FacilitiesFilterValue,
  FreePlacesFilterValue,
  FreePlacesValue,
  MaximumStayFilterValue,
  MaximumStayValue,
  SearchAreaFilterValue,
  RegistrationFilterValue,
} from 'ha/types/SearchFilters';

import { PriceFilterValue } from './types';

export interface LocalState {
  types: TypeFilterValue;
  rooms: RoomsFilterValue;
  price: PriceFilterValue;
  country: string;
  gender: GenderFilterValue;
  facilities: FacilitiesFilterValue;
  freePlaces: FreePlacesFilterValue;
  maximumStay: MaximumStayFilterValue;
  searchArea: SearchAreaFilterValue;
  registration: RegistrationFilterValue;
}

export interface SearchFiltersContextValue {
  localState: LocalState;
  onChangeTypes: (_: TypeFilterValue) => void;
  onChangeRooms: (_: RoomsFilterValue) => void;
  onChangePrice: (_: PriceFilterValue) => void;
  onChangeCountry: (_: string | undefined) => void;
  onChangeGender: (_: GenderFilterValue) => void;
  onChangeFacilities: (_: FacilitiesFilterValue) => void;
  onChangeFreePlaces: (_: FreePlacesFilterValue) => void;
  onChangeMaximumStay: (_: MaximumStayFilterValue) => void;
  onChangeSearchAreaFilter: (_: SearchAreaFilterValue) => void;
  onChangeRegistration: (_: RegistrationFilterValue) => void;
  clearFilters: (filtersToKeep?: Array<keyof LocalState>) => void;
  isFilterEmpty: (filterName: keyof LocalState) => boolean;
  applyFilters: () => void;
}

export const EmptyState: LocalState = {
  types: [],
  rooms: {
    bedroomCount: [],
  },
  price: [],
  gender: [],
  country: '',
  facilities: [],
  freePlaces: FreePlacesValue.ZERO,
  maximumStay: MaximumStayValue.ZERO,
  searchArea: [],
  registration: [],
};

export const SearchFiltersContext =
  React.createContext<SearchFiltersContextValue>({
    localState: EmptyState,
    /* eslint-disable @typescript-eslint/no-unused-vars */
    onChangeTypes: (_: TypeFilterValue) => {},
    onChangeRooms: (_: RoomsFilterValue) => {},
    onChangePrice: (_: PriceFilterValue) => {},
    onChangeCountry: (_: string | undefined) => {},
    onChangeGender: (_: GenderFilterValue) => {},
    onChangeFacilities: (_: FacilitiesFilterValue) => {},
    onChangeFreePlaces: (_: FreePlacesFilterValue) => {},
    onChangeMaximumStay: (_: MaximumStayFilterValue) => {},
    onChangeSearchAreaFilter: (_: SearchAreaFilterValue) => {},
    onChangeRegistration: (_: RegistrationFilterValue) => {},
    clearFilters: () => {},
    isFilterEmpty: () => true,
    applyFilters: () => {},
    /* eslint-enable @typescript-eslint/no-unused-vars */
  });

SearchFiltersContext.displayName = 'SearchFiltersContext';
